import { TextField, InputAdornment } from "@mui/material";
import { WidgetProps } from "@rjsf/utils";
import { inputStyles, renderLabel, renderDescriptionTooltip } from "./common";

// Textarea Widget for multi-line text without formatting toolbar
export const TextareaWidget = (props: WidgetProps) => {
  const { id, value, label, onChange, required, disabled, readonly, placeholder, options, schema } = props;
  const minRows = (options?.rows as number) || 3;

  return (
    <TextField
      id={id}
      fullWidth
      value={value ?? ""}
      onChange={(event) => onChange(event.target.value || undefined)}
      disabled={disabled}
      slotProps={{
        input: {
          readOnly: readonly,
          endAdornment: schema.description ? (
            <InputAdornment position="end">
              {renderDescriptionTooltip(schema.description)}
            </InputAdornment>
          ) : null,
        },
      }}
      placeholder={placeholder}
      label={renderLabel(label, !!required)}
      required={required}
      multiline
      minRows={minRows}
      maxRows={10}
      variant="outlined"
      sx={inputStyles}
    />
  );
};
